import styled from "styled-components";

export const ScrollButtonContainer = styled.div`
  position: absolute;
  right: 25px;
  bottom: ${({ addedSpace }) => (addedSpace ? "85px" : "25px")};
  z-index: 1;

  img {
    height: 50px;
    width: 50px;
    cursor: pointer;
    padding: 15px;
    background: ${({ theme }) => theme.button.bg.scroll};
    box-shadow: 0px 0px 5px 0px ${({ theme }) => theme.button.bg.primary};
    border-radius: ${({ theme }) => theme.constants.BORDER_RADIUS_8};
  }

  @media (max-width: 768px) {
    right: 22px;
    bottom: 80px;
  }
`;
